export enum EtaLocationType {
  GEOFENCE = 'geoFence',
  ASSET = 'asset',
  CUSTOM = 'custom',
}

export interface EtaLocation {
  id?: number | string
  title?: string
  latitude: number
  longitude: number
  type: EtaLocationType
  address: string
  plateNumber?: string
  avatar?: string
  speed?: number
  heading?: number
  highRiskArea?: boolean
}

export interface EtaDistanceResult {
  duration: { text: string; value: number } | undefined
  distance: string | undefined
  distanceMeters: number | undefined
  departureTime: Date
  overviewPath: google.maps.LatLngAltitude[] | undefined
  originAddress: string | undefined
  destinationAddress: string | undefined
  bounds: google.maps.LatLngBounds | undefined
}

/**
 * Route calculation status codes surfaced to the user as ETA error messages.
 *
 * Most mirror the Google Maps Directions API status codes (returned in a thrown error's message),
 * with the exception of `NO_ROUTE_FOUND` — a synthetic status we raise when the Routes API resolves
 * successfully but returns no usable route (e.g. an inaccessible geofence), which it does not reject.
 */
export enum EtaRouteStatus {
  ZeroResults = 'ZERO_RESULTS',
  NoRouteFound = 'NO_ROUTE_FOUND',
  NotFound = 'NOT_FOUND',
  OverQueryLimit = 'OVER_QUERY_LIMIT',
  RequestDenied = 'REQUEST_DENIED',
  InvalidRequest = 'INVALID_REQUEST',
}
